/*
 * @Description  : 提供 url 解析的相关信息
 * @usage        :
 * @Date         : 2021-10-26 20:12:27
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @LastEditors: yukizou yukizou@tencent.com
 * @LastEditTime: 2025-08-22 15:01:26
 * @FilePath: /vise/packages/app-share/src/composable/use-provide-url-info.ts
 */

import { provide, reactive } from 'vue';
import { useRoute, LocationQuery } from 'vue-router';

export const PROVIDED_URL_INFO_NAME = Symbol('urlInfo');

export type TUrlInfo = {
  query: LocationQuery & {
    id?: string;
    spid?: string;
    qua?: string;
    collectionid?: string,
    themeid?: string,
    scene?: string,
  }
};

export default function useProvideUrlInfo() {
  const route = useRoute();

  const info: TUrlInfo = reactive({
    query: {},
  });

  const parseEncodedQuery = () => {
    let { fullPath } = route;
    if (fullPath.indexOf('&amp;') >= 0) {
      fullPath = route.fullPath.replaceAll('&amp;', '&');
    }
    const queryIndex = fullPath.indexOf('?');
    if (queryIndex === -1) return {};

    const queryString = fullPath.slice(queryIndex + 1);
    const queryParams = new URLSearchParams(queryString);
    const parsedQuery: Record<string, string> = {};

    queryParams.forEach((value, key) => {
      parsedQuery[key] = value;
    });

    return parsedQuery;
  };

  info.query = parseEncodedQuery();

  const provideInfo = () => {
    provide(PROVIDED_URL_INFO_NAME, info);
  };

  return {
    info,
    provideInfo,
  };
}
